module.exports = __webpack_public_path__ + "static/media/phone-solid.584f89de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone-solid.svg
// module id = 279
// module chunks = 0